import React, { useEffect, useState } from 'react'

import { Box, Collapse, Typography } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'
import { ChevronUp, ChevronDown } from 'react-feather'
import { isEmpty } from 'lodash'
import clsx from 'clsx'

import { routes } from 'TrainingRoutes'
import useStyles from './styles'

const LessonSidebar = ({
  modules,
  activeLessonId,
  portalToken,
  courseId,
  history,
  disabled = false,
}) => {
  const classes = useStyles()

  const activeModuleId = modules?.find((module) =>
    module?.lessons?.some((lesson) => lesson?.id === Number(activeLessonId)),
  )?.id

  const [openModules, setOpenModules] = useState(
    () => new Set(activeModuleId ? [activeModuleId] : []),
  )

  useEffect(() => {
    if (activeModuleId) {
      setOpenModules((previous) => new Set([...previous, activeModuleId]))
    }
  }, [activeModuleId])

  const toggleModule = (moduleId) => {
    setOpenModules((previous) => {
      const next = new Set(previous)
      if (next.has(moduleId)) {
        next.delete(moduleId)
      } else {
        next.add(moduleId)
      }
      return next
    })
  }

  const navigateToLesson = (targetLessonId, kind) => {
    if (disabled) return null
    const targetRoute =
      kind === 'exercise' ? routes.exerciseContent : routes.lessonContent
    const url = targetRoute
      .replace(':portalToken', portalToken)
      .replace(':courseId', courseId)
      .replace(':lessonId', targetLessonId)
    history.push(url)
  }

  if (isEmpty(modules)) return null

  return (
    <Box className={classes.root}>
      {modules.map((module) => {
        const isOpen = openModules.has(module?.id)
        const durationHours = module?.durationHours ?? 0

        return (
          <Box key={module?.id}>
            <Box
              className={classes.moduleHeader}
              onClick={() => toggleModule(module?.id)}
            >
              <Box className={classes.moduleHeaderInner}>
                <Box className={classes.moduleHeaderText}>
                  <Typography className={classes.moduleTitle}>
                    {module?.title}
                  </Typography>
                  <Typography className={classes.moduleMeta}>
                    {module?.lessonsCount}{' '}
                    {module?.lessonsCount === 1 ? 'aula' : 'aulas'} •{' '}
                    {durationHours}
                  </Typography>
                </Box>
                {isOpen ? (
                  <ChevronUp size={16} className={classes.chevron} />
                ) : (
                  <ChevronDown size={16} className={classes.chevron} />
                )}
              </Box>
            </Box>

            <Collapse in={isOpen}>
              {!isEmpty(module?.lessons) &&
                module.lessons.map((lesson) => {
                  const isActive = lesson?.id === Number(activeLessonId)
                  const isExercise = lesson?.kind === 'exercise'

                  return (
                    <Box
                      key={lesson?.id}
                      className={clsx(classes.lessonRow, {
                        [classes.lessonRowActive]: isActive,
                      })}
                      onClick={() => navigateToLesson(lesson?.id, lesson?.kind)}
                    >
                      <Box className={classes.lessonLeft}>
                        <CheckCircle
                          className={clsx(classes.checkIcon, {
                            [classes.checkIconCompleted]: lesson?.completed,
                          })}
                        />
                        <Typography className={classes.lessonTitle}>
                          {lesson?.title}
                        </Typography>
                      </Box>
                      <Box className={classes.lessonRight}>
                        {isExercise ? (
                          <Typography className={classes.lessonMeta}>
                            {lesson?.questionsCount ?? 0} Questões
                          </Typography>
                        ) : (
                          <Typography className={classes.lessonMeta}>
                            {lesson?.durationHours}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  )
                })}
            </Collapse>
          </Box>
        )
      })}
    </Box>
  )
}

export default LessonSidebar
